import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { playerOptionsAtom as playerOptionsQueryAtom } from '@/atoms/queries/players';
import { NumberOption } from '@/types/generic';
import { SectionAtomMap } from '@/types/section';
import { getAtomForSection } from '@/utils/atoms/section';
import { filtersAtom } from '../filter';

const playerSectionMapAtom = atom<SectionAtomMap<NumberOption[]>>(() => ({
  dataLocker: playerOptionsQueryAtom,
  team: atom(async () => []),
  player: atom(async () => []),
}));

export const playerOptionsAtom = atom(getAtomForSection(playerSectionMapAtom));

const unwrappedPlayerOptionsAtom = unwrap(playerOptionsAtom, prev => prev || []);
export const selectedPlayersAtom = atom(get => {
  const playerOptions = get(unwrappedPlayerOptionsAtom);
  const selectedPlayerIds = get(filtersAtom).playerIds;

  return playerOptions.filter(({ value }) => selectedPlayerIds.includes(value));
});
